"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudySubjectStatusHistory = void 0;
class StudySubjectStatusHistory {
}
exports.StudySubjectStatusHistory = StudySubjectStatusHistory;
//# sourceMappingURL=studySubjectStatusHistory.js.map